export default __webpack_public_path__ + "static/font-3cc34a3353626e26eb65b1c456aa76c3.woff";